import React from 'react'
import PropTypes from 'prop-types'
import Measure from 'react-measure'
import FormQuestionSlide from '../slides/FormQuestionSlide'
import EditorTopBar from './EditorTopBar'
import EditorToolbar from './EditorToolbar' 
import EditorInsertButton from './EditorInsertButton'
import SaveStatusIndicator from './SaveStatusIndicator'
import {newQuestion} from '../../utils/newItem'
import Icon from '../misc/Icons'

class QuestionEditor extends React.Component{

	constructor(){
		super()		
		this.handleChangeTemplate=this.handleChangeTemplate.bind(this)
		this.newQuestionEditorTab=this.newQuestionEditorTab.bind(this)
		this.state={    	 
      	  height:0,
      	  width:0,
      	  showDropDown:false,
      	  transformScale:1
		}
	}
 

	sizeChanged(dimensions){
		const height=dimensions.dimensions.height
		const width=dimensions.dimensions.width
		this.setState({height:height})
		this.setState({width:width})
		//transform scale for the whole slide
		let transformScale=1
		if(width && height) {
			if(width / 1.6 > height) {
				transformScale = height / 800
			} else {
				transformScale = width / 1280
			}
		}
		this.setState({transformScale:transformScale})
	}


	



	handleChangeTemplate(newTemplate){
		if(newTemplate==='right' && !this.props.hasImage){
			return null
		}	else{
			return this.props.changeTemplate(newTemplate)
		}
	}

	renderQuestionEditorQuestionCanvas(){
		const {question,isViewOnly,itemIsLockedByAnotherUser}=this.props
		let hasEditedChoices=false //check if any of the choices have been edited
		if(question){	
			for (var i = 0; i < question.choices.length; i++) {
				if(question.choices[i].body !== '\u2063'){
					hasEditedChoices=true
				}
			}		
			let transformScale = this.state.transformScale
			let slideWidth = transformScale * 1280
			let slideHeight = transformScale * 800
			

			return(
				<div className={'itemEditor-canvas itemEditor-canvas--questionEditor ' + (!itemIsLockedByAnotherUser ? ' itemEditor-canvas--lockedByYou' : '') + (itemIsLockedByAnotherUser ? ' itemEditor-canvas--lockedByNotYou' : '')}>

					{!isViewOnly &&
						<EditorToolbar
							disableTemplates={this.props.disableTemplates}
							activeQuestionIsSurvey={this.props.isSurvey} 				
							questionTemplate={this.props.template}
							activeQuestionHasImage={this.props.hasImage}
							isSet={false}
							setToGraded={this.props.setToGraded}
							setToSurvey={this.props.setToSurvey}
							handleChangeTemplate={this.handleChangeTemplate}
							hasImage={this.props.hasImage}
							addChoice={this.props.addChoice}
							canAddChoice={question.choices.length < 4}
							itemIsLockedByAnotherUser={itemIsLockedByAnotherUser}
						/>
					}

					<Measure onMeasure={(dimensions) => {this.sizeChanged({dimensions})}}>
						<div className='itemEditor-canvas-slideLayoutContainer'>

							{question &&

							  <FormQuestionSlide 
							  	{...this.props}
							  	isViewOnly={isViewOnly}
									question={question} 
									onChangeSubmit={this.props.editFormOnChange}
									transformScale={this.state.transformScale}
									isShuffling={this.props.isShuffling}
									isShufflingStart={this.props.isShufflingStart}							
							  />
							} 

							{!isViewOnly &&
								<div className="itemEditor-canvas-controlsContainer" style={{width: `${slideWidth}px`, height: `${slideHeight}px`}}>
										<div className="itemEditor-canvas-controls--below">								
											{hasEditedChoices && 
											<button disabled={itemIsLockedByAnotherUser} className={'itemEditor-shuffleBtn btn btn--large btn--white ' + (this.props.isShuffling ? 'shuffleBtn--shuffling' : '')} onClick={() =>{this.props.shuffleChoices()}} tabIndex={0}>
													<div className='itemEditor-shuffleBtn-shufflingIcon'/>
													<span className='itemEditor-shuffleBtn-label'>Shuffle Choices</span>											
											</button>
											}
											
											<div className='itemEditor-shuffleBtn-text-hint'>
														Press <strong>ENTER</strong> to Shuffle
											</div>
											{!hasEditedChoices && 
												<button onClick={()=>{this.props.setToTrueFalse()}} disabled={itemIsLockedByAnotherUser} className={'itemEditor-trueFalseBtn btn btn--large btn--white' + (!hasEditedChoices ? ' itemEditor-trueFalseBtn--show' : ' itemEditor-trueFalseBtn--hide' )} >
													Set as True/False
												</button>
											}

									</div>
			
									<div className="itemEditor-canvas-controls--right" style={{width: `calc((100vw - (${slideWidth}px)) / 2)`}}>
										
									{!this.props.disableImageSearch &&
											<div className="itemEditor-insertPanel">
												<EditorInsertButton label="Insert Image" icon="newImage" isLocked={itemIsLockedByAnotherUser} onClickFunction={() =>{this.props.showImageSearchModal()}} />
											</div>
										}
										{this.props.disableImageSearch &&
											<div className="itemEditor-insertPanel">																	
												<input 
													id='file'
													type='file'
													value={''}
													style={{position:'absolute', opacity: '0', height:'0', width: '0'}}
													name='uploadImage'
													onChange={this.props.handleFileUpload}
													disabled={itemIsLockedByAnotherUser || isViewOnly}
													accept=".png,.gif,.jpg,.jpeg,.tif,.tiff"
												/>							     
												<label htmlFor='file'>
													<EditorInsertButton label="Insert Image" icon="newImage" />
												</label>
										
											</div>
										}

								
									</div>
								</div>	
							}
						</div>
					</Measure>
				  			  	
				</div>
			)
		} 
	}

	newQuestionEditorTab(){
		newQuestion(this.props.question.folder,this.props.question.repo)
	}

 
	render(){		

		let isPublicConsumer = false
		if(this.props.parentRepo && this.props.parentRepo.role === 'consumer'){
			isPublicConsumer = true
		}

		let isPublicAuthor = false
		if(this.props.parentRepo && this.props.parentRepo.role === 'author'){
			isPublicAuthor = true
		}
			
		const {isViewOnly,itemIsLockedByAnotherUser} = this.props

		return(
			<div className={'itemEditor itemEditor--questionEditor' + (itemIsLockedByAnotherUser ? ' itemEditor--questionEditor--lockedByNotYou' : '') + (isViewOnly ? ' itemEditor--questionEditor--isViewOnly' : '')}>
				<EditorTopBar 
					{...this.props}
					newQuestionEditorTab={this.newQuestionEditorTab}
					item={this.props.question}
					isSet={false}
					isPublicAuthor={isPublicAuthor}
					isPublicConsumer={isPublicConsumer}
					archiveItem={this.props.archiveQuestion}	
					itemIsLockedByAnotherUser={itemIsLockedByAnotherUser}	
					showRepoSelectionModal={this.props.showRepoSelectionModal}			
				/>
				
				<div className='itemEditor-content'>					
					{this.renderQuestionEditorQuestionCanvas()}
				</div>
				{this.props.currentQuestion &&
					<SaveStatusIndicator
						item={this.props.currentQuestion}
						parentRepo={this.props.parentRepo}
						isSaving={this.props.isSaving}
						unableToSave={this.props.unableToSave}
						itemIsLockedByAnotherUser={this.props.itemIsLockedByAnotherUser}
						lastEditedBy={this.props.currentQuestion.lastEditedBy}
						lock={this.props.lock}
					/>
				}	

				{this.props.isViewOnly && !isPublicConsumer &&
					<div className='itemEditor-viewOnlyBanner'>
						<Icon name='eye'/> View only
					</div>
				}

			</div>
		)
	}
}





QuestionEditor.propTypes = {
	question: PropTypes.object,

}



export default QuestionEditor

